import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* =========================================================
   🌐 BASE URL
========================================================= */
const baseUrl =
  process.env.REACT_APP_BACKEND_BASE_URL;

/* =========================================================
   🧪 FETCH TESTS FOR MEDICAL USER
========================================================= */
export const fetchTestsForMedicalUser = createAsyncThunk(
  "labTests/fetchTestsForMedicalUser",
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/appointments/medical-user/${userId}`,
      );

      const tests = response.data?.appointments || [];

      return tests;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch tests",
      );
    }
  },
);

/* =========================================================
   🧠 SLICE
========================================================= */
const labTestsSlice = createSlice({
  name: "labTests",

  initialState: {
    tests: [],
    loading: false,
    error: null,
  },

  reducers: {
    /* ---------------- CLEAR STATE ---------------- */
    clearTestsState: (state) => {
      state.tests = [];
      state.loading = false;
      state.error = null;
    },

    /* =====================================================
       🚀 AUTO REFRESH FIX (IMPORTANT)
       - updates single test instantly after upload
    ===================================================== */
    updateSingleTest: (state, action) => {
      const { testId, labFiles, labDescription } = action.payload;

      const index = state.tests.findIndex((t) => t.testid === testId);

      if (index !== -1) {
        state.tests[index] = {
          ...state.tests[index],
          labFiles: labFiles ?? state.tests[index].labFiles,
          labDescription: labDescription ?? state.tests[index].labDescription,
        };
      }
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------------- FETCH START ---------------- */
      .addCase(fetchTestsForMedicalUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      /* ---------------- FETCH SUCCESS ---------------- */
      .addCase(fetchTestsForMedicalUser.fulfilled, (state, action) => {
        state.loading = false;
        state.tests = action.payload;
      })

      /* ---------------- FETCH FAIL ---------------- */
      .addCase(fetchTestsForMedicalUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

/* =========================================================
   📤 EXPORTS
========================================================= */
export const { clearTestsState, updateSingleTest } = labTestsSlice.actions;

export default labTestsSlice.reducer;
